var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("template-card-v2", {
        attrs: {
          oneLog: _vm.oneLog,
          linkedtype: _vm.linkedtype,
          linkedid: _vm.linkedid
        },
        scopedSlots: _vm._u([
          {
            key: "icon",
            fn: function() {
              return [
                _c("CompassObject", {
                  attrs: { object: "phone", size: "small" }
                })
              ]
            },
            proxy: true
          },
          {
            key: "label",
            fn: function() {
              return [
                _c("person-list-light", {
                  attrs: {
                    list: [_vm.oneLog.staffs.params.list[0]],
                    placeholderSingular: "Collaborateur",
                    placeholderPlural: "Collaborateurs"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "content",
            fn: function() {
              return [
                _c("div", [
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "phone-call-main-information-container" },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              { staticClass: "phone-call-card-date-container" },
                              [
                                _c("CompassIcon", {
                                  attrs: {
                                    size: "small",
                                    icon: "calendar-fill"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "typographies-paragraph-medium-semibold"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$t.__(
                                            "common.labels.due_date",
                                            _vm.date
                                          )
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.isLate
                                  ? _c("BadgeActivityStatus", {
                                      attrs: { tag: _vm.activityStatus }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.oneLog.subject
                              ? _c(
                                  "CompassTag",
                                  {
                                    staticClass: "phone-call-card-tag",
                                    attrs: {
                                      type: "dot",
                                      size: "small",
                                      color: "yellow"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.oneLog.subject) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "phone-call-card-container" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "phone-call-card-title" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "typographies-paragraph-medium-semibold"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(_vm.oneLog.label) +
                                            "\n                                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "typographies-paragraph-small-semibold phone-call-card-timer__container"
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.oneLog.status))
                                        ]),
                                        _vm._v(" "),
                                        _vm.oneLog.duration.length
                                          ? _c("span", [_vm._v("- ")])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.oneLog.duration.length
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "typographies-paragraph-small-regular phone-call-card-timer__content-time"
                                              },
                                              [
                                                _c("CompassIcon", {
                                                  staticClass: "mx-1 gray-80",
                                                  attrs: {
                                                    type: "secondary",
                                                    size: "extra-small",
                                                    icon: "nav-timetracking"
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.oneLog.duration
                                                    ) +
                                                    "\n                                        "
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "phone-call-card-buttons-container" },
                          [
                            !_vm.oneLog.is_done
                              ? _c("TimelineActivityRescheduleButton", {
                                  attrs: { activity: _vm.activityForReschedule }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.shouldDisplayUpdateStatusButton
                              ? _c("ActivityUpdateStatusButton", {
                                  attrs: {
                                    isDone: _vm.oneLog.is_done,
                                    pending: _vm.isUpdateStatusLoading,
                                    label: _vm.labelStatusButton,
                                    statusButtonType: "secondary"
                                  },
                                  on: { updateStatus: _vm.updateStatus }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "typographies-paragraph-medium-regular phone-call-card__content rich-text-style",
                      class: _vm.editorClass,
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.addBrToEmptyPragraphs(_vm.oneLog.description)
                        )
                      }
                    })
                  ])
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }